module.exports = __webpack_public_path__ + "media/step5_animation_Brueche.e00c5c51.mp4";